import "./App.css";
import { AnimeFAQ } from "./components/AnimeFAQ";
import { HomePage } from "./components/HomePage";
function App(): JSX.Element {
  return (
    <>
      <HomePage />
      <AnimeFAQ />
    </>
  );
}

export default App;

